const baseRoutes = {
  CAMPAIGN: "/campaigns",
  EMBEDDING_SEARCH: "/smart-search",
  INDEX: "/",
  LOGIN: "/login",
  ORGANIZATION: "/organization",
  PASSWORD_RESET: "/password-reset",
  PORTFOLIO: "/portfolio",
  SIGNUP: "/signup",
  TECHNOLOGY: "/portfolio/technology",
};

const routes = {
  CAMPAIGN: `${baseRoutes.CAMPAIGN}`,
  CREATE_CAMPAIGN: `${baseRoutes.CAMPAIGN}/create`,
  EMBEDDING_SEARCH: `${baseRoutes.EMBEDDING_SEARCH}`,
  EMBEDDING_SEARCH_COMPANIES: `${baseRoutes.EMBEDDING_SEARCH}/companies`,
  EMBEDDING_SEARCH_CONTACTS: `${baseRoutes.EMBEDDING_SEARCH}/contacts`,
  LOGIN: baseRoutes.LOGIN,
  ORGANIZATION: baseRoutes.ORGANIZATION,
  PORTFOLIO: baseRoutes.PORTFOLIO,
  TECHNOLOGY: `${baseRoutes.PORTFOLIO}/technology`,
} as const;

export default routes;
